module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var operations = {
	"INSERT": "Добавлено",
	"UPDATE": "Изменено",
	"DELETE": "Удалено"
};

function getValue(item, name, field) {
	if (!Util.isDefined(item[name])) {
		return "Не указано";
	}

	/*if (field.text) {
		return field.text(item);
	}*/

	return item[name];
}


    ; __append("\n\n<div class=\"gl-cards__view_section\">\n	<div class=\"title\">\n		<b>История</b>\n	</div>\n	<div>\n		<table class=\"table\">\n			<tr>\n				<td><b>Дата/Время</b></td>\n				<td><b>Операция</b></td>\n				<td><b>Блок</b></td>\n				<td><b>Изменения</b></td>\n				<td><b>Пользователь</b></td>\n			</tr>\n			")
    ;  Util.each(history, function (item) { 
    ; __append("\n			<tr>\n				<td>")
    ; __append(escapeFn( item.datetime ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( operations[item.operation] ))
    ; __append("</td>\n				<td>")
    ; __append(escapeFn( definition[item.type].title ))
    ; __append("</td>\n				<td>\n					")
    ;  if (item.operation == "UPDATE" && item.old && item.item && item.diff) { 
    ; __append("\n					")
    ;  Util.each(item.diff, function (name) { 
    ; __append("\n					")
    ;  var field = definition[item.type].fields[name] 
    ; __append("\n					")
    ;  if (field) { 
    ; __append("\n					<div><span style=\"font-weight: bold; text-decoration: underline;\">")
    ; __append(escapeFn( field.title ))
    ; __append("</span></div>\n					<div style=\"padding-left: 10px\">Старое значение: <b>")
    ; __append(escapeFn( getValue(item.old, name, field) ))
    ; __append("</b></div>\n					<div style=\"padding-left: 10px\">Новое значение: <b>")
    ; __append(escapeFn( getValue(item.item, name, field) ))
    ; __append("</b></div>\n					")
    ;  } 
    ; __append("\n					")
    ;  }); 
    ; __append("\n					")
    ;  } 
    ; __append("\n				</td>\n				<td>\n					")
    ; __append( Html.encode(Glonass.TrackableHistory.initiator(item.item, { organization: true }), { br: true }) )
    ; __append("\n				</td>\n			</tr>\n			")
    ;  }); 
    ; __append("\n		</table>\n	</div>\n</div>\n")
  }
  return __output.join("");

}